<script>
/**
 * Fix return value of input when the value is erased
 * instead of returning an empty string (default html behavior)
 * return a null value
 *
 * original files
 * https://github.com/ElemeFE/element/blob/dev/packages/input-number/src/input-number.vue
*/
import { InputNumber } from 'element-ui';

export default {
  name: 'NullableNumberInput',
  props: {
    // value of null value
    nullValue: {
      type: [Number, String],
      default: null
    },
    // change default setting to hide controls by default
    controls: {
      type: Boolean,
      default: false
    }
  },
  extends: Object.assign({}, InputNumber, {
    computed: Object.assign({}, InputNumber.computed, {
      displayValue() {
        // over ride of displayValue to set decimal only if needed
        if (this.userInput !== null) {
          return this.userInput;
        }
        if (this.currentValue === '') {
          return this.nullValue;
        }
        // end
        let currentValue = this.currentValue;
        if (typeof currentValue === 'number' && currentValue % 1 !== 0) {
          if (this.stepStrictly) {
            const stepPrecision = this.getPrecision(this.step);
            const precisionFactor = Math.pow(10, stepPrecision);
            currentValue = Math.round(currentValue / this.step) *
              precisionFactor * this.step / precisionFactor;
          }
          if (this.precision !== undefined) {
            currentValue *= Math.pow(10, this.precision) /
              Math.pow(10, this.precision);
          }
        }
        return currentValue;
      }
    }),
    methods: Object.assign({}, InputNumber.methods, {
      // over ride to allow null value
      handleInput(value) {
        if (value === '') {
          this.currentValue = this.nullValue;
          this.userInput = this.nullValue;
        } else {
          this.userInput = value;
        }
        // end
        this.$emit('input', this.userInput);
      }
    }),
    watch: Object.assign({}, {
      value: {
        immediate: true,
        handler(value) {
          // over ride to allow null value
          if (value === null && this.nullValue === null) {
            this.currentValue = this.nullValue;
            this.userInput = null;
            this.$emit('input', this.nullValue);
            return;
          }
          // end
          // call original function
          const originalFunction = InputNumber.watch.value.handler.bind(this);
          originalFunction(value);
        }
      }
    })
  })
};
</script>
